import { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../utility/helper";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const AdminForm = () => {
  const [chapters, setChapters] = useState([]);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    chapter_id: "",
    admin_name: "",
    admin_email: "",
    admin_number: "",
    admin_desi: "",
    role_id: "",
  });

  const [errors, setErrors] = useState({}); // <-- For inline errors

  useEffect(() => {
    const fetchChapters = async (type = "all") => {
      try {
        const token = sessionStorage.getItem("token");

        let url = `${baseurl}/admin/chapters`;
        if (type) {
          url += `?type=${type}`; 
        }

        const res = await fetch(url, {
          headers: {
            Authorization: token,
          },
        });

        const data = await res.json();
        setChapters(data);
      } catch (err) {
        console.error("Error fetching chapters:", err);
      }
    };

    fetchChapters();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // For admin_number, allow only digits and max 10
    if (name === "admin_number") {
      const numericValue = value.replace(/\D/g, "");
      if (numericValue.length <= 10) {
        setFormData({ ...formData, [name]: numericValue });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }

    // Clear the error message on change
    setErrors({ ...errors, [name]: "" });
  };

  // Validation function
  const validate = () => {
    const newErrors = {};

    if (!formData.chapter_id) newErrors.chapter_id = "Please select a chapter";
    if (!formData.admin_name.trim()) newErrors.admin_name = "Admin name is required";
    if (!formData.admin_desi.trim()) newErrors.admin_desi = "Admin designation is required";

    if (formData.admin_email && !/\S+@\S+\.\S+/.test(formData.admin_email)) {
      newErrors.admin_email = "Email is invalid";
    }

    if (!formData.admin_number) {
      newErrors.admin_number = "Mobile number is required";
    } else if (!/^\d{10}$/.test(formData.admin_number)) {
      newErrors.admin_number = "Enter a valid 10-digit mobile number";
    }

    if (!formData.role_id) newErrors.role_id = "Please select a user role";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return; // Stop submission if validation fails

    try {
      const response = await axios.post(`${baseurl}/admin/addadmin`, formData);
      Swal.fire({
        title: "Success!",
        text: "Admin Added successfully!",
        icon: "success",
        timer: 5000,
        timerProgressBar: true,
        willClose: () => {
          setTimeout(() => {
            navigate("/admin/Manageadmin");
          }, 500);
        },
      });

      setFormData({
        chapter_id: "",
        admin_name: "",
        admin_email: "",
        admin_number: "",
        admin_desi: "",
        role_id: "",
      });
    } catch (error) {
      console.error("Error inserting admin:", error);
      const errorMessage = error.response?.data?.message || "Failed to add admin.";
      Swal.fire("Error!", errorMessage, "error");
    }
  };

  return (
    <div className="content container-fluid">
       <button className="cl-back-btn " onClick={() => window.history.back()}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M10 3L5 8l5 5"/></svg>
                Back
            </button>
      <div className="profile-section">
        <div className="container mt-4">
          <center>
            <h2>Add New Admin</h2>
          </center>
          <br />
          <form onSubmit={handleSubmit} className="row g-3">
            <div className="col-md-6">
              <label htmlFor="chapter">Select Chapter:</label>
              <select
                className="form-select"
                id="chapter"
                name="chapter_id"
                value={formData.chapter_id}
                onChange={handleChange}
              >
                <option value="" disabled>
                  Select Chapter
                </option>
                {chapters
                  .filter((term) => term.chapter_id !== 1)
                  .map((term) => (
                    <option key={term.chapter_id} value={term.chapter_id}>
                      {term.chapter_name}
                    </option>
                  ))}
              </select>
              {errors.chapter_id && <small className="text-danger">{errors.chapter_id}</small>}
            </div>

            <div className="col-md-6">
              <label className="form-label">Admin Name:</label>
              <input
                className="form-control"
                placeholder="Enter Name"
                name="admin_name"
                value={formData.admin_name}
                onChange={handleChange}
              />
              {errors.admin_name && <small className="text-danger">{errors.admin_name}</small>}
            </div>

            <div className="col-md-6">
              <label className="form-label">Admin Email:</label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter Email"
                name="admin_email"
                value={formData.admin_email}
                onChange={handleChange}
              />
              {errors.admin_email && <small className="text-danger">{errors.admin_email}</small>}
            </div>

            <div className="col-md-6">
              <label className="form-label">Admin Mobile No:</label>
              <input
                placeholder="Enter phone number"
                className="form-control"
                name="admin_number"
                value={formData.admin_number}
                onChange={handleChange}
              />
              {errors.admin_number && <small className="text-danger">{errors.admin_number}</small>}
            </div>

             <div className="col-md-6">
              <label className="form-label">Admin Designation:</label>
              <input
                className="form-control"
                placeholder="Enter Designation For eg: Chairman, President etc.."
                name="admin_desi"
                value={formData.admin_desi}
                onChange={handleChange}
              />
              {errors.admin_desi && <small className="text-danger">{errors.admin_desi}</small>}
            </div>

            <div className="col-md-6">
              <label className="form-label">Select UserRole:</label>
              <select
                className="form-select"
                name="role_id"
                value={formData.role_id}
                onChange={handleChange}
              >
                <option value="" disabled>
                  Select Role
                </option>
                <option value="2">Admin</option>
                <option value="3">Manager</option>
                <option value="4">Test Admin</option>
                <option value="5">Transaction Admin</option>
              </select>
              {errors.role_id && <small className="text-danger">{errors.role_id}</small>}
            </div>

            <div className="col-12">
              <center>
                <button type="submit" style={{ borderRadius: "8px" }}>
                  Submit
                </button>
              </center>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminForm;
